"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _reactToastify = require("react-toastify");

var _formik = require("formik");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _schemaDeposit = _interopRequireDefault(require("./schemaDeposit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      currencySymbol = _ref.currencySymbol,
      getWallet = _ref.getWallet,
      onError = _ref.onError,
      balance = _ref.balance,
      setTransactionsUpdated = _ref.setTransactionsUpdated;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      serverError = _useState2[0],
      setServerError = _useState2[1];

  var validate = function validate(values) {
    var errors = {};

    if (values.amount < 5 || values.amount > 200) {
      errors.amount = "".concat(translations.errorDeposit.replace(/\$1/g, currencySymbol));
    }

    return errors;
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, _ref2) {
      var setSubmitting, depositRes, _response$data, _response$data4, _response$data5, response, _response$data2, _response$data2$error, _response$data3, _response$data3$error;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmitting = _ref2.setSubmitting;
              _context.prev = 1;
              _context.next = 4;
              return _axios.default.post("/wallet/deposit", {
                password: values.password,
                amount: +values.amount * 100
              });

            case 4:
              depositRes = _context.sent;
              setSubmitting(false);
              setServerError(undefined);
              setTransactionsUpdated(true);
              getWallet();

              _reactToastify.toast.success(translations.depositSuccess);

              window.xtremepush("tag", "walletDeposit", JSON.stringify({
                AppName: process.env.REACT_APP_TITLE,
                amount: values.amount
              }));
              _context.next = 18;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              response = _context.t0.response;

              if ((response === null || response === void 0 ? void 0 : response.code) === 401) {
                onError(response);
              }

              if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.errors) {
                if (response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && (_response$data2$error = _response$data2.errors) !== null && _response$data2$error !== void 0 && _response$data2$error.amount) {
                  setServerError("".concat(translations.amount, " ").concat(translations.invalid));
                } else if (response !== null && response !== void 0 && (_response$data3 = response.data) !== null && _response$data3 !== void 0 && (_response$data3$error = _response$data3.errors) !== null && _response$data3$error !== void 0 && _response$data3$error.password) {
                  setServerError("".concat(translations.password, " ").concat(translations.invalid));
                }
              } else if ((response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.message) === "This user has no payment source") {
                setServerError(translations.withdrawErrorNoCardAdded);
              } else if (response !== null && response !== void 0 && (_response$data5 = response.data) !== null && _response$data5 !== void 0 && _response$data5.message) {
                setServerError(response.data.message);
              } else {
                onError(response);
              }

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 13]]);
    }));

    return function onSubmit(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    validationSchema: (0, _schemaDeposit.default)(translations),
    onSubmit: onSubmit,
    initialValues: {
      amount: "",
      password: ""
    },
    validate: validate
  }, function (_ref5) {
    var isSubmitting = _ref5.isSubmitting,
        isValid = _ref5.isValid,
        values = _ref5.values,
        errors = _ref5.errors,
        dirty = _ref5.dirty,
        handleChange = _ref5.handleChange,
        setFieldValue = _ref5.setFieldValue;
    return /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
      isError: errors.amount,
      onChange: function onChange(e) {
        if (serverError) {
          setServerError(undefined);
        }

        handleChange(e);
      },
      value: values.amount,
      name: "amount",
      type: "tel",
      prefix: currencySymbol,
      placeholder: translations.amount
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
      isVisible: errors.amount
    }, errors.amount, errors.balance), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
      isError: !errors.amount && errors.password,
      onChange: function onChange(e) {
        if (serverError) {
          setServerError(undefined);
        }

        handleChange(e);
      },
      value: values.password,
      name: "password",
      type: "password",
      placeholder: translations.password
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
      isVisible: !errors.amount && errors.password || serverError && isValid
    }, errors.password, serverError), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
      noDisabledStyles: true,
      disabled: !isValid || isSubmitting || !dirty,
      errorMessage: serverError,
      isLoading: isSubmitting,
      size: "sm"
    }, translations.deposit));
  });
};

var _default = Wrapper;
exports.default = _default;